<div class="etf-home-page-container">
  <div class="etf-home-page-header">
    <img src="{{ deployUrl }}/assets/etf/bnpp-logo.png" />
    <div class="etf-portal-label">
      <span class="etf-label">ETF</span>
      <span>Nav Portal</span>
    </div>
  </div>
  <div class="etf-home-content-container">
    <div class="etf-nav-portal-logo-container">
      <img src="{{ deployUrl }}/assets/etf/etfLogo.png" />
    </div>
    <div class="login-btn-container">
      <a (click)="onClickLogin()">
        <img class="login-btn" src="{{ deployUrl }}/assets/etf/btn_login.png" />
      </a>
      <a (click)="openRegisterModal()">
        <img class="login-btn" src="{{ deployUrl }}/assets/etf/btn_register.png" />
      </a>
    </div>
    <p-dialog
      header="Register"
      [(visible)]="showRegisterModal"
      [modal]="true"
      [style]="{ width: '50vw' }"
      [draggable]="false"
      [resizable]="false"
      [baseZIndex]="1000"
      [dismissableMask]="false"
    >
      <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
        <div class="p-field">
          <label for="title">Title<span class="required-asterisk">*</span></label>
          <p-dropdown id="title" formControlName="title" [options]="titles" placeholder="Select a Title"></p-dropdown>
        </div>
        <div class="p-field">
          <label for="firstName">First Name<span class="required-asterisk">*</span></label>
          <s-input-message [config]="userFormValidationModel.validators.firstName">
            <input pInputText type="text" formControlName="firstName" maxlength="100" />
          </s-input-message>
        </div>
        <div class="p-field">
          <label for="lastName">Last Name<span class="required-asterisk">*</span></label>
          <s-input-message [config]="userFormValidationModel.validators.lastName">
            <input pInputText type="text" formControlName="lastName" maxlength="100" />
          </s-input-message>
        </div>
        <div class="p-field">
          <label for="email">Email Address<span class="required-asterisk">*</span></label>
          <s-input-message [config]="userFormValidationModel.validators.email">
            <input pInputText formControlName="email" maxlength="100" />
          </s-input-message>
        </div>
        <div class="p-field">
          <label for="company">Company<span class="required-asterisk">*</span></label>
          <p-dropdown
            id="company"
            formControlName="company"
            [options]="companies"
            placeholder="Select a Company"
          ></p-dropdown>
        </div>
        <div class="p-field">
          <label for="emailGroup">Email Group<span class="required-asterisk">*</span></label>
          <s-input-message [config]="userFormValidationModel.validators.emailGroup">
            <textarea
              pInputTextarea
              id="emailGroup"
              formControlName="emailGroup"
              placeholder="If several, separate each with comma."
            ></textarea>
          </s-input-message>
          <div
            *ngIf="
              registerForm.get('emailGroup').hasError('invalidEmailGroup') && registerForm.get('emailGroup').touched
            "
            class="error-message"
          >
            Invalid email group. Please ensure all emails are valid and separated by commas.
          </div>
        </div>
        <div class="p-field">
          <label for="phone">Phone Number<span class="required-asterisk">*</span></label>
          <s-input-message [config]="userFormValidationModel.validators.phoneNumber">
            <input pInputText formControlName="phoneNumber" placeholder="Enter valid country code" maxlength="25" />
          </s-input-message>
        </div>
        <div *ngIf="errorMessage" class="error-message">
          {{ errorMessage }}
        </div>
        <div class="submit-button-container">
          <button pButton type="submit" label="Submit" [disabled]="!registerForm.valid"></button>
        </div>
      </form>
    </p-dialog>

    <p-dialog
      class="success-message-dialog"
      header="Success"
      [(visible)]="showSuccessModal"
      [modal]="true"
      [style]="{ width: '800px' }"
      [draggable]="false"
      [resizable]="false"
      [baseZIndex]="1000"
      [dismissableMask]="true"
      (onHide)="closeSuccessModal()"
    >
      <div class="successMsg">
        <div class="msgHeader">Thank you for your Login request on "ETF NAV Portal".</div>
        <div class="msgContent">Your request has been considered and we will soon notify you with relevant action.</div>
        <div class="contactMsg">
          "You can contact us by email : <a href="mailto:paris_bfi_webteam@dev.fr">paris_bfi_webteam&#64;dev.fr</a> or by
          phone : &lt;&lt; +44 (0) 2 7595 1844 &gt;&gt; for further clarification"
          <br />
          <br />
        </div>
      </div>
    </p-dialog>

    <p-dialog
      header="{{ popUpTitle }}"
      [(visible)]="showPopUp"
      [modal]="true"
      [style]="{ width: '800px' }"
      [draggable]="false"
      [resizable]="false"
      [baseZIndex]="1000"
      [dismissableMask]="true"
      (onHide)="closePopUp()"
    >
      <div class="pop-up-content" [innerHTML]="popUpContent"></div>
    </p-dialog>
  </div>
  <footer class="etf-home-page-footer">
    <div class="footer__copyright">
      <p>©<span data-bind="text: copyrightYear">2019</span> BNP Paribas - All rights reserved</p>
    </div>
    <div class="disclaimer-terms-container">
      <a href="javascript:void(0)" (click)="openPopUp('NAV_TERMS_OF_USE')">Terms of Use & Regulation Notice</a>
      <a href="javascript:void(0)" (click)="openPopUp('NAV_DISCLAIMER')">Disclaimer </a>
      <a href="https://cib.bnpparibas.com/Miscellaneous/Cookies-Policy/page.aspx/215">Cookies Policy </a>
      <a href="javascript:void(0)" (click)="openPopUp('NAV_CONTACT_US')" class="contact-link">
        <img width="11" height="11" src="{{ deployUrl }}/assets/smartd/email.svg" alt="Email" />Contact
      </a>
    </div>
  </footer>
</div>
